/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NewRelation/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Add from './Add/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function NewRelation({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/NewAddress/Content/NewRelation"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Add'}>
<Add
  viewPath={`${viewPath}/Add`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}